import React, { useState, useCallback } from 'react';
import SignupCollectionAction from '../SignupCollectionAction';
import SignupCollection from '../SignupCollection';
import Signin from '../../popup/Signin';

const Step1Collection = () => {
    const [isSending, setIsSending] = useState(false);
    const [email, setEmail] = useState(false);
    const [canContinue, setCanContinue] = useState(false);

    const hasError = useCallback((error) => {
        setCanContinue(Boolean(!error));
    }, []);

    const getSending = useCallback((value) => {
        setIsSending(value);
    }, []);

    const getEmail = useCallback((value) => {
        setEmail(value);
    }, []);

    window.localStorage.removeItem('hx:collection:hasPausedOnce');

    return (
        <>
            <div className="step-container">
                <div className="step-circle">
                    <span>1</span>
                </div>
                <SignupCollection getSending={getSending} hasError={hasError} getEmail={getEmail} />
            </div>
            <SignupCollectionAction step={1} isValid={canContinue} isSending={isSending} />
            <Signin email={email} />
        </>
    );
};

export default Step1Collection;
